import { useMemo } from 'react';
import { useApiQuery } from './query';
import type { AgentList, InsurerList, ProductLineList, TenantSettings } from './types';

// Référentiels du tenant pour les filtres et libellés ; mis en cache 5 minutes.

const LONG = { staleTime: 5 * 60_000 };

export function useReferentials() {
  const insurers = useApiQuery<InsurerList>('/v1/insurers', undefined, LONG);
  const productLines = useApiQuery<ProductLineList>('/v1/product-lines', undefined, LONG);
  const agents = useApiQuery<AgentList>('/v1/agents', undefined, LONG);
  return useMemo(
    () => ({
      insurers: insurers.data?.items ?? [],
      productLines: productLines.data?.items ?? [],
      agents: agents.data?.items ?? [],
      insurerName: (id: string | null | undefined) =>
        insurers.data?.items.find((i) => i.id === id)?.displayName ?? '',
      productName: (id: string | null | undefined) =>
        productLines.data?.items.find((p) => p.id === id)?.labelFr ?? '',
      agentName: (id: string | null | undefined) =>
        agents.data?.items.find((a) => a.id === id)?.name ?? '',
    }),
    [insurers.data, productLines.data, agents.data],
  );
}

export function useTenant() {
  return useApiQuery<TenantSettings>('/v1/tenant', undefined, LONG);
}
